/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3, _BioExamPrescriptionEditionFormComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import RouterService from "@ember/routing/router-service";
import { service } from "@ember/service";
import saveSendMessage from "core/components/chat/utils/save-send-message";
import { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import JournalEventBasedComponent from "core/components/forc/abstract/journal-event-based-component";
import BioExamPrescribedJournalEvent from "core/models/bio-exam-prescribed-journal-event";
import AnalyticsService from "core/services/analytics";
import SemeiaSessionService from "core/services/session";
import { BufferedChangeset } from "ember-changeset/types";
/* eslint-disable parog-web/migrate-non-patch-forms */
let BioExamPrescriptionEditionFormComponent = (_class = (_BioExamPrescriptionEditionFormComponent = class BioExamPrescriptionEditionFormComponent extends JournalEventBasedComponent {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "analytics", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "router", _descriptor3, this);
    this.chatMessage = "Bonjour, \nJe viens de vous éditer une nouvelle ordonnance. Elle est jointe à ce message. \nBonne journée.";
  }

  // Always dirty because we always are in creation mode
  get isDirty() {
    return true;
  }
  async save() {
    this.forceQuit = true;
    // The validation doesn't work if we don't launch it manually
    this.args.changeset.validate();
    if (this.args.changeset.get("isValid")) {
      await this.args.changeset.save();
      await this.draft.onDidSave();
      const savedModel = this.args.changeset.data;
      if (savedModel.patient.authorizesAppUsage) {
        await saveSendMessage({
          willSendMessage: true,
          chatMessage: this.chatMessage
        }, {
          store: this.store,
          patient: savedModel.patient,
          analytics: this.analytics
        });
        await this.store.createRecord("patient-chat-message-sent-journal-event", {
          occurredAt: new Date(),
          triggeringJournalEvent: savedModel,
          patient: savedModel.patient,
          body: "Nouvelle ordonnance reçue"
        }).save();
      }
      const alertsTriggered = this.store.peekAll("alert-triggered-journal-event");
      const alert = alertsTriggered.find(alert => alert.triggeringJournalEvent?.id == this.args.oldBioExamPrescription?.id);
      if (alert) {
        alert.processAlert({
          actionTaken: "bio-exam-prescription-renewed"
        });
      }
      this.router.transitionTo("medics-web.protected.patients.patient.prescriptions.bio-exam-display", savedModel.patient.id, savedModel.id);
    }
  }
  async _openPrescriptionInNewTab(savedModel) {
    // Open the PDF prescription in a new tab
    if (savedModel) {
      this.router.replaceWith("medics-web.protected.patients.patient.feature.component", this.model, "prescription", "bio-exam-display");
    } else {
      throw new Error(`Impossible to open the PDF prescription because there is no JournalEvent found corresponding to the type : bio-exam-prescribed-journal-event}`);
    }
  }
  onCancelPrescription() {
    this.router.transitionTo("medics-web.protected.patients.patient.dashboard", this.args.changeset.data.patient);
  }
}, _defineProperty(_BioExamPrescriptionEditionFormComponent, "fullComponentId", "prescription/bio-exam-edition-form"), _defineProperty(_BioExamPrescriptionEditionFormComponent, "forcDisplayName", "Prescription d'examens biologiques"), _defineProperty(_BioExamPrescriptionEditionFormComponent, "journalEventClass", BioExamPrescribedJournalEvent), _BioExamPrescriptionEditionFormComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "analytics", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "onCancelPrescription", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onCancelPrescription"), _class.prototype), _class);
export { BioExamPrescriptionEditionFormComponent as default };